var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/x-entity-picker.ts
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { FormField } from "@adornis/formfield/form-field.js";
import "@adornis/popover/x-dropdown-search-selection.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { distinctUntilChanged, takeUntil } from "rxjs";
import { entityPickerSearch, subscibeEntityByEntityPickerValue } from "./entity-picker-utils.js";
var XEntityPicker = class extends FormField {
  constructor() {
    super(...arguments);
    this.options = new RXController(this, null);
    this._entity = new RXController(
      this,
      this.value.observable,
      (value$) => subscibeEntityByEntityPickerValue(this.options.observable, value$)
    );
    this.icon = void 0;
    this.loadedInitially = false;
    this.renderItem = (item, index, value) => xComponents(html`
      <x-flex
        ${css({
      padding: `${this.spacing.sm} ${this.spacing.md}`,
      cursor: "pointer"
    })}
        space="md"
      >
        <x-text> ${this.renderString(item, index)} </x-text>
        ${index === (this.options.value?.limit ?? 20) - 1 ? html`<x-text ${css({ color: this.colors.neutral })}> Suche für Weitere... </x-text>` : nothing}
      </x-flex>
    `);
    this.renderString = (x) => x?.toString() ?? "";
  }
  connectedCallback() {
    super.connectedCallback();
    this._entity.observable.pipe(takeUntil(this.disconnected), distinctUntilChanged()).subscribe((v) => {
      this.loadedInitially = true;
      this.dispatchEvent(
        new CustomEvent("entity-picked", {
          detail: {
            value: v
          }
        })
      );
    });
  }
  render() {
    if (!this.options.value) {
      console.warn("No options found", this);
      return html`No options given`;
    }
    let icon = this.icon;
    if (this.options.value.iconEmpty && !this.value.value && (!this.options.value.iconEmpty.permission || this.options.value.iconEmpty.permission()))
      icon = this.options.value.iconEmpty.icon;
    if (this.options.value.iconValue && this.value.value && (!this.options.value.iconValue.permission || this.options.value.iconValue.permission()))
      icon = this.options.value.iconValue.icon;
    if (this._entity.isLoading && !this.loadedInitially)
      return xComponents(html`<x-flat-loader></x-flat-loader> `);
    return xComponents(html`
      <x-flex>
        <x-dropdown-search-selection
          flex
          ${injectAttributesOf(this, ["tabindex", "icon"])}
          icon=${ifDefined(icon)}
          .renderString=${this.renderString}
          .renderItem=${this.renderItem}
          .value=${!!this._entity.value !== !!this.value.value ? ["Found ID with no corresponding entity."] : this._entity.value}
          .search=${entityPickerSearch(this.options.value).bind(this)}
          @value-picked=${(e) => {
      this.value.next(e.detail.value?._id ?? null);
      const event = new CustomEvent("value-picked", {
        detail: {
          value: e.detail.value?._id
        }
      });
      this.dispatchEvent(event);
    }}
          @value-changed=${(e) => {
      if (e.detail.value?._id === this.value.value)
        return;
      const event = new CustomEvent("value-changed", {
        detail: {
          value: e.detail.value?._id ?? null
        }
      });
      this.dispatchEvent(event);
    }}
          @icon-click=${() => {
      if (this.options.value?.iconEmpty?.action && !this.value.value)
        this.options.value.iconEmpty.action();
      if (this.options.value?.iconValue?.action && this.value.value)
        this.options.value.iconValue.action(this._entity.value);
      this.dispatchEvent(new CustomEvent("icon-click"));
    }}
          @cleared=${() => {
      this.value.next(null);
      this.dispatchEvent(new CustomEvent("cleared"));
    }}
        ></x-dropdown-search-selection>
      </x-flex>
    `);
  }
};
__decorateClass([
  property({ attribute: false })
], XEntityPicker.prototype, "options", 2);
__decorateClass([
  state()
], XEntityPicker.prototype, "_entity", 2);
__decorateClass([
  property({ reflect: true })
], XEntityPicker.prototype, "icon", 2);
XEntityPicker = __decorateClass([
  customElement("x-entity-picker")
], XEntityPicker);
export {
  XEntityPicker
};
